import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DualPricingState } from '../reducers';

export const selectDualPricingState = createFeatureSelector<DualPricingState>('dualPricing');

export const selectDualPricingLoading = createSelector(
  selectDualPricingState,
  (state: DualPricingState) => state.loading
);

export const selectDualPricing = createSelector(
  selectDualPricingState,
  (state: DualPricingState) => state?.dualPricing
);

export const selectDualPricingList = createSelector(
  selectDualPricingState,
  (state: DualPricingState) => state.dualPricingList
);

export const selectDualPricingId = createSelector(
  selectDualPricingState,
  (state: DualPricingState) => state.dualPricingId
);

export const selectDualPricingError = createSelector(
  selectDualPricingState,
  (state: DualPricingState) => state.error
);
